import React from 'react';

import {VersionsSidebarItem} from 'app/procedures/components/ProcedureDetailPage/ProcedurePageSidebar/VersionsSidebarItem';
import {getObjectCurrentVersionURL} from 'app/urls';
import {getPathFromURL} from 'app/utils/urls';

import type {LeftSidebarMenuButton} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';
import type {
  ListPolicyVersionSerializedType,
  ProcedureHashidSerializedType,
  ProcedureVersionSerializedType,
  ProcessHashidSerializedType,
  ProcessVersionSerializedType,
} from 'sweet-types';

export function VersionsMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  params,
  versions,
  active,
  location,
}: LeftSidebarMenuButton<ItemType> & {
  versions: Array<
    ItemType extends ProcessHashidSerializedType
      ? ProcessVersionSerializedType
      : ItemType extends ProcedureHashidSerializedType
      ? ProcedureVersionSerializedType
      : ListPolicyVersionSerializedType
  >;
}) {
  const {versionid: versionId} = params;

  return (
    <VersionsSidebarItem
      object={object}
      link={getPathFromURL(
        getObjectCurrentVersionURL(object, versionId, location.search)
      )}
      versions={versions}
      forceTooltipShow={forceTooltipShow}
      active={active}
    />
  );
}
